const countyConfigBillingScheduleReducer = (state = [{}], action) => {
  switch (action.type) {
    case 'LANDSHARK_COUNTY_CONFIG_BILLING_SCHEDULE':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigBillingScheduleReducer;